import React from 'react';

export default function PerPageSelector({
  value = 10,
  onChange,
  options = [10, 25, 50, 100],
  size = 'sm'
}) {
  const sizeClasses = {
    sm: 'px-2 py-1 text-xs',
    md: 'px-3 py-2 text-sm',
    lg: 'px-4 py-3 text-base'
  };

  return (
    <select
      value={value}
      onChange={(e) => onChange(parseInt(e.target.value))}
      className={`border border-gray-300 rounded-md bg-white text-gray-900 focus:border-blue-500 focus:ring-1 focus:ring-blue-500 focus:outline-none ${sizeClasses[size]}`}
    >
      {options.map(option => (
        <option key={option} value={option}>
          {option}
        </option>
      ))}
    </select>
  );
}